(() => {
  const node = document.getElementById('kf-wishlist-copy');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  config.root = (config.root || '/').replace(/\/?$/, '/');
  let Core = window.KultfrauDiscoveryCore, Filter = window.KultfrauWishlistFilterCore;
  const copy = config.filter;
  const mounted = new WeakSet(), colors = new Map();
  const emptyFilters = () => ({category: '', color: '', size: ''});
  const text = (element, value) => { if (element.textContent !== value) element.textContent = value; };
  const make = (tag, className, content) => {
    const element = document.createElement(tag);
    element.className = className;
    if (content) element.textContent = content;
    return element;
  };
  const button = (className, label, action) => {
    const element = make('button', className, label);
    element.type = 'button';
    element.addEventListener('click', action);
    return element;
  };
  let sequence = 0;
  const mount = () => {
    for (const page of document.querySelectorAll('wishlist-page')) {
      if (mounted.has(page)) continue;
      mounted.add(page);
      page.classList.add('kf-wishlist');
      const id = `kf-wishlist-filter-${++sequence}`;
      let applied = emptyFilters(), records = [], trigger, badge, dialog, summary, summaryText, summaryNote, empty, note, retry;
      let fields = {}, optionsSignature = '', loading = false, failed = false;
      const resultText = () => {
        const count = records.filter(record => Filter.matches(record, applied)).length;
        return copy.results.replace(/{{\s*count\s*}}/g, count).replace(/{{\s*total\s*}}/g, records.length);
      };
      const reset = () => {
        applied = emptyFilters();
        for (const field of Object.values(fields)) field.value = '';
        refresh();
      };
      const readRecords = () => {
        const items = page.wishlist?.items;
        if (!Array.isArray(items)) return [];
        return items.map(item => Filter.prepare(item, colors.get(item.product?.handle), Core));
      };
      const build = header => {
        trigger = button('kf-wishlist-filter-trigger', '', () => {
          dialog.showModal();
          refresh();
          for (const key of Object.keys(fields)) fields[key].value = applied[key];
          loadColors();
        });
        trigger.setAttribute('aria-label', copy.openFilter);
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', id);
        trigger.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 7h18M3 17h18"/><circle cx="9" cy="7" r="3" fill="currentColor"/><circle cx="15" cy="17" r="3" fill="currentColor"/></svg>';
        badge = make('span', 'kf-wishlist-filter-count');
        badge.setAttribute('aria-hidden', 'true');
        badge.hidden = true;
        trigger.append(badge);
        header.append(trigger);
        summary = make('div', 'kf-wishlist-filter-summary');
        summaryText = make('span', '');
        summaryText.setAttribute('role', 'status');
        summaryNote = make('p', 'kf-wishlist-filter-note');
        summaryNote.setAttribute('role', 'status');
        summary.append(summaryText, button('', copy.reset, reset), summaryNote);
        summary.hidden = true;
        header.append(summary);
        dialog = make('dialog', 'kf-wishlist-filter-dialog');
        dialog.id = id;
        dialog.setAttribute('aria-labelledby', `${id}-title`);
        const heading = make('div', 'kf-wishlist-filter-heading');
        const title = make('h2', '', copy.filterTitle);
        title.id = `${id}-title`;
        const close = button('kf-wishlist-filter-close', '', () => dialog.close());
        close.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
        close.setAttribute('aria-label', copy.close);
        heading.append(title, close);
        const form = make('form', 'kf-wishlist-filter-form');
        for (const key of ['category', 'color', 'size']) {
          const label = make('label', '', copy[key]);
          const select = make('select', '');
          select.dataset.wishlistFilter = key;
          select.name = key;
          label.append(select);
          form.append(label);
          fields[key] = select;
        }
        note = make('p', 'kf-wishlist-filter-note');
        note.setAttribute('role', 'status');
        retry = button('kf-wishlist-filter-retry', copy.retry, () => loadColors());
        retry.hidden = true;
        const actions = make('div', 'kf-wishlist-filter-actions');
        const apply = make('button', '', copy.apply);
        apply.type = 'submit';
        actions.append(button('', copy.reset, reset), apply);
        form.append(note, retry, actions);
        form.addEventListener('submit', event => {
          event.preventDefault();
          applied = Object.fromEntries(Object.entries(fields).map(([key, field]) => [key, field.value]));
          refresh();
          dialog.close();
        });
        dialog.append(heading, form);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => trigger.focus({preventScroll: true}));
        page.append(dialog);
        empty = make('div', 'kf-wishlist-filter-empty');
        empty.append(make('p', '', copy.empty), button('', copy.reset, reset));
        empty.hidden = true;
      };
      const refresh = () => {
        const title = page.querySelector('.wk-header .wk-title');
        if (!title) return;
        if (!page.querySelector('.kf-wishlist-subtitle')) title.after(make('p', 'kf-wishlist-subtitle', config.subtitle));
        for (const link of page.querySelectorAll('.wk-wishlist-empty-callout a[href]')) {
          const url = new URL(link.href, location.origin);
          if (url.origin !== location.origin || !/\/collections\/all(?:es)?\/?$/.test(url.pathname)) continue;
          url.pathname = `${(config.root || '/').replace(/\/$/, '')}/collections/alles`;
          if (config.themeRole !== 'main' && config.themeId) url.searchParams.set('preview_theme_id', config.themeId);
          if (link.href !== url.href) link.href = url.href;
        }
        for (const card of page.querySelectorAll('wishlist-product-card')) {
          const image = card.querySelector('img.wk-image');
          const name = card.querySelector('.wk-product-title')?.textContent.trim();
          if (image && name && !image.alt) image.alt = name;
        }
        if (!Core || !Filter || !copy) return;
        const header = title.closest('.wk-header');
        if (!trigger) build(header);
        else if (!header.contains(trigger)) header.append(trigger, summary);
        if (!page.contains(dialog)) page.append(dialog);
        const body = page.querySelector('.wk-body');
        if (body && !body.contains(empty)) body.append(empty);
        const active = Object.values(applied).filter(Boolean).length;
        if (!active && !dialog.open) {
          trigger.hidden = !(page.wishlist?.items?.length);
          trigger.classList.toggle('is-active', false);
          badge.hidden = true;
          summary.hidden = true;
          empty.hidden = true;
          for (const card of page.querySelectorAll('.kf-wishlist-filtered-out')) card.classList.remove('kf-wishlist-filtered-out');
          return;
        }
        records = readRecords();
        const facets = Filter.options(records);
        const signature = JSON.stringify(facets);
        if (signature !== optionsSignature) {
          optionsSignature = signature;
          for (const [key, field] of Object.entries(fields)) {
            const previous = dialog.open ? field.value : applied[key];
            const values = facets[{category: 'categories', color: 'colors', size: 'sizes'}[key]];
            const all = {category: copy.allCategories, color: copy.allColors, size: copy.allSizes}[key];
            const label = value => key === 'category' ? copy.categories[value] || value : value === '__unknown__' ? copy.unknownColor : key === 'color' ? copy.colors?.[value] || value : value;
            field.replaceChildren(new Option(all, ''), ...values.map(value => new Option(label(value), value)));
            if (previous && !values.includes(previous)) field.add(new Option(label(previous), previous));
            field.value = previous;
          }
        }
        const byId = new Map(records.map(record => [String(record.id), record]));
        for (const card of page.querySelectorAll('wishlist-product-card')) {
          const record = byId.get(card.dataset.wishlistItemId);
          card.classList.toggle('kf-wishlist-filtered-out', !!record && !Filter.matches(record, applied));
        }
        trigger.hidden = records.length === 0 && !active;
        trigger.classList.toggle('is-active', !!active);
        badge.hidden = !active;
        text(badge, String(active));
        summary.hidden = !active;
        text(summaryText, resultText());
        summaryNote.hidden = !applied.color || !failed;
        text(summaryNote, failed ? copy.error : '');
        empty.hidden = !active || !records.length || records.some(record => Filter.matches(record, applied));
        fields.color.disabled = loading;
        text(note, loading ? copy.loading : failed ? copy.error : records.some(record => record.colors.includes('__unknown__')) ? copy.incomplete : '');
        note.hidden = !note.textContent;
        retry.hidden = !failed || loading;
      };
      const loadColors = async () => {
        if (loading) return;
        const items = page.wishlist?.items || [];
        const pending = [...new Set(items.filter(item => item.product?.handle && !Filter.prepare(item, colors.get(item.product.handle), Core).colorKnown).map(item => item.product.handle))];
        if (!pending.length) return;
        loading = true;
        failed = false;
        refresh();
        const worker = async () => {
          while (pending.length && page.isConnected) {
            const handle = pending.shift();
            try {
              const url = new URL(`${config.root || '/'}products/${encodeURIComponent(handle)}`, location.origin);
              url.searchParams.set('section_id', 'kf-wishlist-product-data');
              if (config.themeRole !== 'main') url.searchParams.set('preview_theme_id', config.themeId);
              const response = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.timeout(10000)});
              if (!response.ok) throw new Error('Color unavailable');
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const result = JSON.parse(doc.querySelector('[data-wishlist-product-color]')?.textContent || 'null');
              if (result?.handle !== handle || !Object.hasOwn(result, 'color')) throw new Error('Color missing');
              colors.set(handle, typeof result.color === 'string' ? result.color : null);
            } catch { failed = true; }
          }
        };
        await Promise.all(Array.from({length: Math.min(3, pending.length)}, worker));
        loading = false;
        refresh();
      };
      document.addEventListener('kf-wishlist:dependencies', () => {
        Core = window.KultfrauDiscoveryCore;
        Filter = window.KultfrauWishlistFilterCore;
        refresh();
      });
      let frame;
      new MutationObserver(() => {
        if (frame) return;
        frame = requestAnimationFrame(() => { frame = null; refresh(); });
      }).observe(page, {childList: true, subtree: true});
      refresh();
    }
    return mounted.has(document.querySelector('wishlist-page'));
  };
  if (!mount()) {
    const observer = new MutationObserver(() => { if (mount()) observer.disconnect(); });
    observer.observe(document.documentElement, {childList: true, subtree: true});
  }
})();
